<style lang="less">
.confirm {
	width: 35% !important;

	p {
		overflow: initial;
		white-space: initial !important;
	}
}
</style>
<style type="text/css" scoped lang="less">
/deep/ .el-switch__label {
	z-index: 1 !important;
}

p {
	white-space: inherit !important;
}

.el-dropdown {
	vertical-align: top;
}

.el-dropdown + .el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
	color: #409eff;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.useruse {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 0.6rem;
	background: #fff;
	border-radius: 2px;
	box-sizing: border-box;
	margin-bottom: 1rem;

	.useruseleft,
	.useruseright {
		display: flex;
		align-items: center;
	}

	.useruseleft {
		justify-content: flex-start;
		width: 50%;
	}

	.useruseright {
		justify-content: flex-end;
		width: 50%;
	}

	.useruseleft > p {
		padding: 0.4rem 0.8rem;
		// box-sizing: border-box;
		border: 1px solid;
		margin-right: 0.6rem;
		text-align: center;
		background: #0a68e3;
		color: #fff;
		font-size: 0.8rem;
		font-weight: 700;
		display: flex;
		align-items: center;
		border-radius: 5px;

		span {
			margin: 0 2px;
		}

		span:first-child {
			font-size: 1rem;
		}
	}

	.useruseleft > p:first-child:hover {
		background: #0d72ff;
	}

	.useruseleft > p:nth-of-type(2):hover {
		background: #11e4f7;
	}

	.useruseleft > p:nth-of-type(2) {
		background: #0ec9d6;
	}

	.useruseleft > p:last-child {
		background: #07b446;
	}

	.useruseleft > p:last-child:hover {
		background: #07d54f;
	}

	.useruseright {
		li {
			// height: 1rem;
			margin-right: 0.2rem;
			// width: 8rem;

			/deep/ .el-dropdown-link.el-dropdown-selfdefine {
				display: flex;
				align-items: center;
				justify-content: space-between;

				span {
					display: block;
					padding: 0.31rem;
					border: 1px solid #e2e2e2;
					color: #585858;
					font-size: 0.8rem;
				}

				i {
					display: block;
					padding: 0.51rem;
					border: 1px solid #dddddd;
					border-left: 0;
					color: #000;
					font-size: 0.8rem;
				}
			}
		}

		li:nth-of-type(3),
		li:nth-of-type(4),
		li:nth-of-type(2) {
			margin-right: 0.4rem;
			// width: 6rem;
		}

		li:nth-of-type(2) {
			span {
				// padding: 0.24rem !important;
			}
		}
	}
}

.tabslis {
	/deep/ & ::-webkit-scrollbar {
		width: 5px;
		height: 8px;
		background: linear-gradient(to right, #2e61bf, #60c363);
	}

	& ::-webkit-scrollbar {
		width: 10px;
		height: 5px;
		// background: red;
	}

	& ::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	/deep/ .el-table {
		th,
		td {
			text-align: center;
		}

		tr:nth-child(2n) {
			background-color: #fff;
		}

		tr:nth-child(2n-1) {
			background-color: #f2f2f2;
		}

		td {
			button {
				color: #fff;
				border-radius: 5px;
			}

			.looking {
				background: #0acf97;
				margin-left: 10px;
			}

			.looking:hover {
				background: #0ae8a6;
			}

			.giveempower {
				background: #ff8300;
			}

			.edit {
				background: #169bd5;
			}

			.edit:hover {
				background: #18aceb;
			}

			.delete {
				background: #f2125e;
				margin-left: 0.5rem;
			}

			.delete:hover {
				background: #ff1365;
			}
		}
	}
}

button {
	color: #fff;
	border-radius: 5px;
}

.looking {
	background: #0acf97;
	margin-left: 10px;
}

.looking:hover {
	background: #0ae8a6;
}

.giveempower {
	background: #ff8300;
}

.edit {
	background: #169bd5;
}

.edit:hover {
	background: #18aceb;
}

.delete {
	background: #f2125e;
}

.delete:hover {
	background: #ff1365;
}

.tablestitilw {
	width: 100%;
	padding: 0.8rem 0.8rem;
	box-sizing: border-box;
	background-color: #f7f7f7;
	color: #333;
	font-size: 0.9rem;
	font-weight: 700;
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.swipers {
	/deep/ .switchStyle .el-switch__label {
		position: absolute;
		display: none;
		color: #ffffff;
	}

	/deep/ .switchStyle .el-switch__label--left {
		z-index: 9;
		left: 25px;
	}

	/deep/ .switchStyle .el-switch__label--right {
		z-index: 9;
		left: 0px;
		top: 0;
	}

	/deep/ .switchStyle .el-switch__label.is-active {
		display: block;
	}

	/deep/ .switchStyle.el-switch .el-switch__core,
	/deep/ .el-switch .el-switch__label {
		width: 60px !important;
	}
}

/deep/ .el-dialog__header {
	padding: 14px 19px 10px;
	background: #05a34a;
	color: #fff;
	font-size: 1.2rem;

	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 1.4rem;
	}

	.dialog-header-title {
		span {
			margin-left: 0.6rem;
		}
	}
}

.qxchoex {
	display: flex;
	align-items: center;

	.qxchoexipt {
		padding: 0rem 0.4rem;
		border-radius: 8px;
		border: 1px solid #ccc;
		width: 80%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
	}

	/deep/ .el-dropdown {
		button {
			background-color: transparent;
			color: #000;
			height: 1rem;
		}

		.el-dropdown-link {
			color: #000;

			i {
				font-size: 1.2rem;
			}
		}
	}

	/deep/ .el-tag--mini {
		height: 26px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/deep/ .el-tag {
		background-color: #22af47;
		border-color: #22af47;
		color: #fff;
		margin: 0.4rem 1rem 0.4rem 0;

		i {
			color: #fff;
		}

		i:hover {
			color: #000;
			background: #fff;
		}
	}
}

.okdiolog {
	background-color: #f0b104;
	border-color: transparent;
}

.okdiolog:hover {
	background-color: #ffbd06;
	color: #000;
}

.clocediolog {
	background-color: #4ec0cc;
	border-color: transparent;
}

.clocediolog:hover {
	background-color: #54d3de;
	color: #000;
}

.changeuser {
	text-align: center;
}

.musts {
	color: red;
	margin-top: 0.3rem;
	font-size: 1rem;
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}
</style>
<template>
	<div>
		<titles titlename="用户列表" titlecontent="用户列表是控制用户信息的地方" :mbx="paths"></titles>
		<div class="useruse">
			<div class="useruseleft">
				<p v-if="isusersshow" style="cursor: pointer;" @click="gouserslist()" v-preventReClick>
					<span class="el-icon-circle-plus-outline"></span>
					<span>添加用户</span>
				</p>
				<p v-if="isusersshow" @click="getalluserlist()" style="cursor: pointer;" v-preventReClick>
					<span style="cursor: pointer;" class="el-icon-upload2"></span>
					<input
						v-if="ischanges"
						@change="changeallupload"
						accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
						type="file"
						ID="fileSelect"
						runat="server"
						ref="alluserlist"
						style="display: none;"
					/>
					<span>批量添加用户</span>
				</p>
				<p v-if="isusersshow" style="background-color: #FF8300;cursor: pointer;" @click="outExcel()" v-preventReClick>
					<span class="el-icon-download" style="cursor: pointer;"></span>
					<span>下载用户模板</span>
				</p>
				<!-- <p>
					<span class="el-icon-upload2"></span>
					<span>导出用户</span>
				</p> -->
			</div>
			<ul class="useruseright">
				<li class="col-xs-2 col-sm-2 col-md-4 col-lg-4" style="width: 50%;">
					<el-input @blur="searchs()" @input="searchs()" size="small" placeholder="请输入用户名" prefix-icon="el-icon-search" v-model="input2"></el-input>
				</li>
				<li>
					<el-dropdown @command="getuserlistas">
						<p class="el-dropdown-link">
							<span>{{ schoolname }}</span>
							<i class="el-icon-menu"></i>
						</p>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="allschool">全部</el-dropdown-item>
							<el-dropdown-item :command="item" v-for="(item, index) in userschoollist" :key="index">{{ item.si_name_cn }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</li>

				<!-- <li>
					<el-dropdown @command="getuserltype">
						<p class="el-dropdown-link">
							<span>用户类型</span><i class="el-icon-guide"></i>
						</p>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="">
								全部
							</el-dropdown-item>
							<el-dropdown-item :command="item.ut_guid" v-for="(item,index) in usertypelist" :key="index">
								{{item.ut_typeName}}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</li> -->
			</ul>
		</div>

		<p class="tablestitilw">用户数据</p>
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column fixed type="index" :resizable="false" :index="indexMethod" label="序号" width="50"></el-table-column>
							<!-- <el-table-column prop="ut_Name" label="用户类型" width="100">
							</el-table-column> -->
							<el-table-column prop="ui_userName" label="用户名" :resizable="false" width="120">
								<template slot-scope="scope">
									<p @click="handleCopyLink(scope.row, $event)">{{ scope.row.ui_userName }}</p>
								</template>
							</el-table-column>
							<el-table-column label="头像" :resizable="false" width="80">
								<template slot-scope="scope">
									<el-popover placement="top-start" title="" trigger="hover">
										<img v-if="scope.row.ui_photoPath == null" src="../../images/header.jpg" alt="" style="width: 150px;height: 150px;border-radius: 50%;" />
										<img v-if="scope.row.ui_photoPath != null" :src="scope.row.ui_photoPath" alt="" style="width: 150px;height: 150px;border-radius: 50%;" />
										<img
											v-if="scope.row.ui_photoPath == null"
											slot="reference"
											src="../../images/header.jpg"
											style="width: 40px;height: 40px;border-radius: 50%;"
										/>
										<img
											v-if="scope.row.ui_photoPath != null"
											slot="reference"
											:src="scope.row.ui_photoPath"
											style="width: 40px;height: 40px;border-radius: 50%;"
										/>
									</el-popover>
									<span>{{ scope.scope }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="ui_realName" :resizable="false" label="真实姓名" width="120"></el-table-column>
							<el-table-column prop="ui_joyNumber" :resizable="false" label="学号"></el-table-column>
							<el-table-column prop="usex" :resizable="false" label="性别" width="50"></el-table-column>
							<el-table-column prop="SchoolName" :resizable="false" label="所属学校"></el-table-column>
							<el-table-column prop="ProName" :resizable="false" label="所属专业"></el-table-column>
							<el-table-column prop="ClaName" :resizable="false" label="所属班级"></el-table-column>
							<el-table-column prop="jslist" :resizable="false" label="角色"></el-table-column>
							<el-table-column prop="studs" :resizable="false" label="状态" width="120">
								<template slot-scope="scope">
									<div class="swipers">
										<el-switch
											style="display: block"
											v-model="scope.row.sys_status"
											active-color="#00cc77"
											class="switchStyle"
											inactive-color="#F00000"
											active-text="启用"
											inactive-text="禁用"
											:active-value="true"
											:inactive-value="false"
											@change="switchChangeFin(scope.row)"
										></el-switch>
									</div>
								</template>
							</el-table-column>
							<el-table-column fixed="right" label="操作" width="300">
								<template slot-scope="scope">
									<div class="userusec d-sm-none d-md-block">
										<el-button size="small" :class="'looking'" @click="lookings(scope.row)">
											<el-tooltip class="item" effect="dark" content="查看" placement="bottom-end"><span class="el-icon-view"></span></el-tooltip>
										</el-button>

										<el-button size="small" class="giveempower" @click="giveem(scope.row)">
											<el-tooltip class="item" effect="dark" content="授权" placement="bottom-end"><span class="el-icon-money"></span></el-tooltip>
										</el-button>
										<el-button size="small" @click="handleClick(scope.row)" class="edit">
											<el-tooltip class="item" effect="dark" content="编辑" placement="bottom-end"><span class="fas fa-eye-dropper"></span></el-tooltip>
										</el-button>

										<template>
											<el-popconfirm
												@confirm="resvesa(scope.row)"
												confirm-button-text="确定"
												cancel-button-text="取消"
												icon="el-icon-info"
												icon-color="red"
												title="确定重置用户密码嘛？"
											>
												<el-button slot="reference" size="small" class="edit" style="background-color: #606266;">
													<el-tooltip class="item" effect="dark" content="重置密码" placement="bottom-end">
														<span class="el-icon-refresh"></span>
													</el-tooltip>
												</el-button>
											</el-popconfirm>
										</template>

										<template>
											<el-popconfirm
												@confirm="clickprovisible(scope.row)"
												confirm-button-text="确定"
												cancel-button-text="取消"
												icon="el-icon-info"
												icon-color="red"
												title="确定删除这条记录吗？"
											>
												<el-button slot="reference" size="small" class="delete">
													<el-tooltip class="item" effect="dark" content="删除" placement="bottom-end"><span class="el-icon-delete"></span></el-tooltip>
												</el-button>
											</el-popconfirm>
										</template>
									</div>
									<div class="userusec d-sm-block d-md-none">
										<el-dropdown trigger="click">
											<p class="el-dropdown-link">···</p>
											<el-dropdown-menu slot="dropdown">
												<el-button size="small" :class="'looking'" @click="lookings(scope.row)">
													<el-tooltip class="item" effect="dark" content="查看" placement="bottom-end"><span class="el-icon-view"></span></el-tooltip>
												</el-button>

												<el-button size="small" class="giveempower" @click="giveem(scope.row)">
													<el-tooltip class="item" effect="dark" content="授权" placement="bottom-end"><span class="el-icon-money"></span></el-tooltip>
												</el-button>
												<el-button size="small" @click="handleClick(scope.row)" class="edit">
													<el-tooltip class="item" effect="dark" content="编辑" placement="bottom-end">
														<span class="fas fa-eye-dropper"></span>
													</el-tooltip>
												</el-button>
												<template>
													<el-popconfirm
														@confirm="resvesa(scope.row)"
														confirm-button-text="确定"
														cancel-button-text="取消"
														icon="el-icon-info"
														icon-color="red"
														title="确定重置用户密码嘛？"
													>
														<el-button slot="reference" size="small" class="edit" style="background-color: #606266;">
															<el-tooltip class="item" effect="dark" content="重置密码" placement="bottom-end">
																<span class="el-icon-refresh"></span>
															</el-tooltip>
														</el-button>
													</el-popconfirm>
												</template>
												<template>
													<el-popconfirm
														@confirm="clickprovisible(scope.row)"
														confirm-button-text="确定"
														cancel-button-text="取消"
														icon="el-icon-info"
														icon-color="red"
														title="确定删除这条记录吗？"
													>
														<el-button slot="reference" size="small" class="delete">
															<el-tooltip class="item" effect="dark" content="删除" placement="bottom-end">
																<span class="el-icon-delete"></span>
															</el-tooltip>
														</el-button>
													</el-popconfirm>
												</template>
											</el-dropdown-menu>
										</el-dropdown>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tabsnun }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="tabsnum"
							:total="totalall"
							:current-page="tabindex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>

		<el-dialog :show-close="false" :before-close="handleClose" :visible.sync="addshow" :close-on-press-escape="false" :close-on-click-modal="false" width="600px">
			<div slot="title" class="dialog-header-title">
				<i class="el-icon-folder-add"></i>
				<span v-if="dioads == '授权'">修改[{{ userSingleobj.ui_userName }}]用户权限（角色）</span>
				<span v-if="dioads == '查看'">查看[{{ userSingleobj.ui_userName }}]用户信息</span>
				<span v-if="dioads == '编辑'">编辑[{{ userSingleobj.ui_userName }}]用户信息</span>
			</div>
			<div class="qxchoex" v-if="dioads == '授权'">
				<p>用户角色：</p>
				<div class="qxchoexipt" v-if="jstags">
					<el-tag size="mini" @close="handleClosejs(item)" closable v-for="(item, index) in qxtaglists" :key="index">{{ item.label }}</el-tag>
				</div>
				<el-dropdown @command="handleCommandjsantu">
					<span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(item, index) in Authoriylist" :key="index" :command="item">{{ item.rl_name }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>

			<div v-if="dioads == '查看'">
				<el-descriptions border :column="2">
					<el-descriptions-item label="用户名">{{ userSingleobj.ui_userName }}</el-descriptions-item>
					<el-descriptions-item label="头像">
						<el-popover placement="top-start" title="" trigger="hover">
							<img v-if="userSingleobj.ui_photoPath == null" src="../../images/header.jpg" alt="" style="width: 150px;height: 150px;border-radius: 50%;" />
							<img v-if="userSingleobj.ui_photoPath != null" :src="userSingleobj.ui_photoPath" alt="" style="width: 150px;height: 150px;border-radius: 50%;" />
							<img v-if="userSingleobj.ui_photoPath == null" slot="reference" src="../../images/header.jpg" style="width: 40px;height: 40px;border-radius: 50%;" />
							<img
								v-if="userSingleobj.ui_photoPath != null"
								slot="reference"
								:src="userSingleobj.ui_photoPath"
								style="width: 40px;height: 40px;border-radius: 50%;"
							/>
						</el-popover>
					</el-descriptions-item>
					<el-descriptions-item label="真实姓名">{{ userSingleobj.ui_realName }}</el-descriptions-item>
					<!-- <el-descriptions-item label="用户类型">
						{{userSingleobj.ut_Name}}
					</el-descriptions-item> -->
					<el-descriptions-item label="学校">{{ userSingleobj.SchoolName }}</el-descriptions-item>
					<el-descriptions-item label="班级">{{ userSingleobj.ClaName }}</el-descriptions-item>
					<el-descriptions-item label="专业">{{ userSingleobj.ProName }}</el-descriptions-item>
					<el-descriptions-item label="性别">{{ userSingleobj.ui_sex ? '男' : '女' }}</el-descriptions-item>

					<el-descriptions-item label="手机">{{ userSingleobj.ui_mobile }}</el-descriptions-item>
					<el-descriptions-item label="邮箱">{{ userSingleobj.ui_email }}</el-descriptions-item>
					<el-descriptions-item label="身份证">{{ userSingleobj.ui_cards }}</el-descriptions-item>
					<el-descriptions-item label="学号">{{ userSingleobj.ui_joyNumber }}</el-descriptions-item>
					<el-descriptions-item :span="3" label="个性签名">{{ userSingleobj.ui_signature }}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div v-if="dioads == '编辑'">
				<el-descriptions border :column="2" labelClassName="changeuser">
					<el-descriptions-item label="用户名">{{ userSingleobj.ui_userName }}</el-descriptions-item>
					<el-descriptions-item label="头像">
						<div>
							<img
								@click="changeimga()"
								v-if="userSingleobj.ui_photoPath == null || userSingleobj.ui_photoPath == ''"
								src="./../../images/header.jpg"
								alt="这个是前台的"
								style="width: 60px;height: 60px;border-radius: 50%;"
							/>
							<!-- v-if="userSingleobj.ui_photoPath != null" -->
							<img @click="changeimga()" v-else :src="userSingleobj.ui_photoPath" alt="这个是后台的" style="width: 60px;height: 60px;border-radius: 50%;" />
						</div>
						<input @change="preview" accept="image/*" ID="fileSelect" runat="server" ref="file" type="file" style="display: none;" name="" id="" />
					</el-descriptions-item>
					<el-descriptions-item label="真实姓名">
						<!-- {{userSingleobj.ui_realName}} -->
						<input
							style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
							type="text"
							v-model="userSingleobj.ui_realName"
						/>
					</el-descriptions-item>
					<!-- <el-descriptions-item>
						<template slot="label">
							<p style="display: flex;align-items: center;">用户类型<span class="musts">*</span></p>
						</template> 
						 <div>
							<select v-model="userSingleobj.ut_guid" class="form-control" id="exampleFormControlSelect1">
								<option value=""> -- 请选择用户类型 --</option>
								<option v-for="(item,index) in typelist" :key="index" :label="item.ut_typeName"
									:value="item.ut_guid">
									{{item.ut_typeName}}
								</option>
							</select>
						</div>
						<input type="text" v-model="userSingleobj.ut_Name">
						{{userSingleobj.ut_Name}} 
					</el-descriptions-item> -->
					<el-descriptions-item label="学校">
						<template slot="label">
							<p style="display: flex;align-items: center;">
								学校
								<span class="musts">*</span>
							</p>
						</template>
						<div>
							<select @change="changeschool()" v-model="userSingleobj.si_guid" class="form-control" id="exampleFormControlSelect1">
								<option value="">-- 请选择所属院校 --</option>
								<option v-for="(item, index) in schoollist" :key="index" :label="item.si_name_cn" :value="item.si_guid">{{ item.si_name_cn }}</option>
							</select>
						</div>
						<!-- {{userSingleobj.SchoolName}} -->
					</el-descriptions-item>
					<el-descriptions-item label="专业" v-if="chengesqxs()">
						<!-- {{classzylist.length}} -->
						<select @change="changeclassgetzy()" v-model="userSingleobj.pro_guid" class="form-control" id="exampleFormControlSelect1">
							<option value="">-- 请选择专业 --</option>
							<option v-for="(item, index) in classzylist" :key="index" :label="item.pro_name" :value="item.pro_guid">{{ item.pro_name }}</option>
						</select>
					</el-descriptions-item>
					<el-descriptions-item label="班级" v-if="chengesqxs()">
						<template slot="label">
							<p style="display: flex;align-items: center;">班级</p>
						</template>
						<div>
							<select v-model="userSingleobj.cla_guid" class="form-control" id="exampleFormControlSelect1">
								<option value="">-- 请选择班级 --</option>
								<option v-for="(item, index) in classlist" :key="index" :label="item.cla_name" :value="item.cla_guid">{{ item.cla_name }}</option>
							</select>
						</div>
					</el-descriptions-item>

					<el-descriptions-item label="性别">
						<div style="display: flex;align-items: center;">
							<el-radio v-model="sexcs" label="1">男</el-radio>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<el-radio v-model="sexcs" label="0">女</el-radio>
						</div>
					</el-descriptions-item>

					<el-descriptions-item label="手机">
						<template slot="label">
							<p style="display: flex;align-items: center;">
								手机
								<!-- <span class="musts">*</span> -->
							</p>
						</template>
						<div>
							<input
								style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
								type="text"
								v-model="userSingleobj.ui_mobile"
								maxlength="11"
							/>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="邮箱">
						<template slot="label">
							<p style="display: flex;align-items: center;">
								邮箱
								<!-- <span class="musts">*</span> -->
							</p>
						</template>
						<div style="position: relative;">
							<input
								style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
								type="text"
								v-model="userSingleobj.ui_email"
							/>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="身份证">
						<input
							style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
							type="text"
							v-model="userSingleobj.ui_cards"
						/>
					</el-descriptions-item>
					<el-descriptions-item label="学号" :span="3">
						<input
							style="padding-left: 6px;box-sizing: border-box;border: 1px solid #ccc;height: 2rem;border-radius: 4px;width: 100%;"
							type="text"
							v-model="userSingleobj.ui_joyNumber"
						/>
					</el-descriptions-item>
					<el-descriptions-item :span="3" label="个性签名">
						<textarea v-model="userSingleobj.ui_signature" name="" id="" rows="10" style="width: 100%;padding: 0.8rem;border: 1px solid #ccc;"></textarea>
					</el-descriptions-item>
				</el-descriptions>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button v-if="dioads == '查看'" class="okdiolog" @click="addshow = false">确 定</el-button>
				<el-button v-if="dioads == '编辑'" class="okdiolog" @click="okedits()" v-preventReClick>确 定</el-button>
				<el-button v-if="dioads == '授权'" class="okdiolog" @click="setqxanth()" v-preventReClick>确 定</el-button>
				<el-button class="clocediolog" @click="addshow = false">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 上传图片截取事件 -->
		<el-dialog title="修改头像" :visible.sync="centerDialogVisible" center width="80%">
			<div style="display: flex;align-items: center;justify-content: center;">
				<div style="display: flex;align-items: center;flex-direction: column;">
					<div style="width: 30rem;height: 30rem;">
						<vueCropper
							ref="cropper"
							:img="headerimg"
							:outputSize="option.outputSize"
							:outputType="option.outputType"
							:info="option.info"
							:full="option.full"
							:canMove="option.canMove"
							:canMoveBox="option.canMoveBox"
							:original="option.original"
							:autoCrop="option.autoCrop"
							:autoCropWidth="option.autoCropWidth"
							:autoCropHeight="option.autoCropHeight"
							:fixedBox="option.fixedBox"
							@realTime="realTime"
						></vueCropper>
					</div>
				</div>

				<div
					style="width: 30rem;
						display: flex;
						justify-content: center;
						align-items: center;
						margin-left: 1rem;"
				>
					<img :src="corappurl" alt="" style="width: 10rem;height: 10rem;border-radius: 50%;border: 1px solid #ccc;" />
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="clocediolog" @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="changeheadimg()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { xlsx } from '../../utils/tabgo';
import {
	getPageUserTypeList,
	getDelete,
	getUserSingle,
	getEditStatus,
	getUpdateUserInfo,
	GetbjGetSchoolList,
	getGetPageUserTypeList,
	GetUserTypeList,
	GetzyProfList,
	ClassInfoGetClassList,
	GetProfListByclassid,
	setImportUser,
	AuthoriyGetRoleList,
	SetUserPermissions,
	GetProClassList
} from '@/request/api/mange/mange.js';
import { setUploadAvatar, setResetPassword } from '@/request/api/userapi/studenthome.js';

import AppOptions from '@/config/AppOptions.vue';

import { VueCropper } from 'vue-cropper';

export default {
	data() {
		return {
			allschool: {
				si_guid: '',
				si_name_cn: '全部'
			},
			// 角色不分页
			schoolname: '全部',
			Authoriylist: [],
			userschoolvalue: '',
			ischanges: true,
			sexcs: '',
			scollid: '',
			typeutguid: '',
			// 4大按钮
			dioads: '',
			userSingleobj: {},
			// 学校列表
			userschoollist: [],
			// 用户类型列表
			usertypelist: [],
			// 权限列表
			qxtaglist: [],
			/* {
					type: '',
					label: '人员管理'
				} */
			// 授权
			addshow: false,
			jstags: false,
			sqanthobj: {},
			//导出表格
			/* 
				
				password: '密码', 
				ui_userName: 'zangsan',
				password: 'gtsd888',
				 */

			listHander: {
				ui_userName: '用户名',
				sex: '性别',
				realname: '真实姓名',
				proname: '专业',
				claname: '所属班级'
			},
			doloads: [
				{
					ui_userName: '张3',
					sex: '男',
					realname: '张三',
					proname: '轨道交通',
					claname: '轨道交通2班'
				}
			],
			// 表格数
			tabsnun: 10,
			tabindex: 1,
			totalall: 10,
			// 表格
			tableData: [],
			// 排序选择框
			options: [
				{
					value: '按时间',
					label: '时间'
				},
				{
					value: '按学校',
					label: '学校'
				},
				{
					value: '按性别',
					label: '性别'
				},
				{
					value: '按用户名',
					label: '用户名'
				}
			],
			value: '',
			// 搜索框
			input2: '',
			paths: [
				{
					path: '/basicmanage/manage',
					name: '用户列表'
				}
			],
			// 院校班级专业类型
			schoollist: [],
			classlist: [],
			typelist: [],
			classzylist: [],
			// 权限控制
			isusersshow: true,
			powershowobj: {},
			// 获取截图 截取图片
			newfilenow: '',
			corappurl: '',
			centerDialogVisible: false,
			option: {
				img: '', // 裁剪图片的地址
				info: true, // 裁剪框的大小信息
				outputSize: 0.8, // 裁剪生成图片的质量
				outputType: 'jpeg', // 裁剪生成图片的格式
				canScale: false, // 图片是否允许滚轮缩放
				autoCrop: true, // 是否默认生成截图框
				autoCropWidth: 200, // 默认生成截图框宽度
				autoCropHeight: 200, // 默认生成截图框高度
				fixedBox: false, // 固定截图框大小 不允许改变
				fixed: false, // 是否开启截图框宽高固定比例
				fixedNumber: [5, 0], // 截图框的宽高比例
				full: true, // 是否输出原图比例的截图
				canMoveBox: true, // 截图框能否拖动
				original: true, // 上传图片按照原始比例渲染
				centerBox: true, // 截图框是否被限制在图片里面
				infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
			},
			headerimg: ''
		};
	},
	components: {
		titles,
		VueCropper
	},
	computed: {
		tabsnum() {
			return Number(this.tabsnun);
		},
		qxtaglists() {
			const keyArr = [];
			this.qxtaglist.forEach((element, index) => {
				keyArr.push(element.label); // 通过label来判断
			});
			const newArr = [];
			const newKey = new Set(keyArr); // key去重
			newKey.forEach(item => {
				const index = keyArr.findIndex(item2 => item2 === item);
				newArr.push(this.qxtaglist[index]);
			});
			// console.log(newArr)

			return newArr;
		}
	},
	created() {
		AppOptions.appEmpty = false;
	},
	beforeMount() {},
	mounted() {
		this.getqxlis();

		this.getuserlist();
		this.getscoollist();

		GetUserTypeList().then(res => {
			// console.log(res)
			this.typelist = res.data.data;
		});
	},
	methods: {
		chengesqxs() {
			if (this.userSingleobj.UserRoleList) {
				console.log(this.userSingleobj.UserRoleList);
				console.log(this.userSingleobj.UserRoleList.some(item => item.rl_guid == 'c8908dba94a74b1d8d7d0845c6e239c7'));
				return this.userSingleobj.UserRoleList.some(item => item.rl_guid == 'c8908dba94a74b1d8d7d0845c6e239c7');
			} else {
				return true;
			}
		},
		getqxlis() {
			let powerlist = JSON.parse(window.sessionStorage.getItem('allbtnlist'));
			// if(!powerlist){
			// 	powerlist = window.sessionStorage.getItem("allbtnlist")
			// }
			// console.log(powerlist,'权限')
			this.powershowobj.powershows = powerlist;
			this.powershowobj.routers = this.$route.path;

			for (var i = 0; i < this.powershowobj.powershows.length; i++) {
				if (this.powershowobj.powershows[i].path == this.powershowobj.routers && this.powershowobj.powershows[i].title == '添加用户') {
					this.isusersshow = true;
					// console.log("可以添加用户")
					return;
				} else {
					this.isusersshow = false;
					// console.log("不可以添加用户")
				}
			}
		},

		handleCopyLink(row, event) {
			// console.log(row)
			let _this = this;

			this.$copyText(event.target.innerText).then(
				function(e) {
					_this.$message({
						showClose: true,
						message: '复制成功',
						type: 'success'
					});
				},
				function(e) {
					_this.$message({
						showClose: true,
						message: '复制失败，请手动复制',
						type: 'error'
					});
				}
			);
		},

		// 一键重置密码
		resvesa(itm) {
			setResetPassword(itm.ui_guid).then(res => {
				// console.log(res)
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
				} else {
					// this.$message(res.data.msg);
				}
			});
		},

		// 批量导入用户
		getalluserlist() {
			this.ischanges = true;
			this.$refs.alluserlist.click();
		},
		changeallupload: function(e) {
			let _this = this;
			let files = e.target.files[0];
			// console.log(e.target.files[0])
			let formdata = new FormData();
			formdata.append('file', files);
			setImportUser(formdata).then(res => {
				// console.log(res)
				if (res.data.code == 1) {
					_this
						.$confirm('成功人数:' + res.data.data.SuccessfulCount + '人,失败人数:' + res.data.data.FailureCount + ',是否下载文件？', '提交成功', {
							confirmButtonText: '是',
							cancelButtonText: '否',
							type: 'success'
						})
						.then(() => {
							location.href = res.data.data.url;
						})
						.catch(() => {
							// console.log("取消")
						});

					_this.ischanges = false;
					window.setTimeout(() => {
						_this.ischanges = true;
					}, 1000);
					this.getuserlist();
				} else {
					_this.$message(res.data.msg);
				}
			});
		},

		// 分页
		changecurr(val) {
			// console.log(`当前页: ${val}`);
			this.tabindex = val;
			this.getuserlist();
		},
		changetablesize() {
			this.getuserlist();
		},
		// 上传头像
		changeimga() {
			this.$refs.file.click();
		},
		preview: function(e) {
			let _this = this;
			let file = e.target.files[0];
			if (!file) {
				return;
			}
			var imgs = '';
			var reader = new FileReader();
			reader.readAsDataURL(e.target.files[0]);
			reader.onload = function() {
				imgs = this.result;
				_this.headerimg = imgs;
				_this.centerDialogVisible = true;
			};

			this.$refs.file.value = '';
		},
		// 真实图片
		realTime(data) {
			// console.log(data);
			// this.previews = data;
			let _this = this;
			this.$refs.cropper.getCropBlob(async data1 => {
				let formData = new FormData();
				if (data1) {
					var timestamp = new Date().getTime() + '.jpg';
					const newFile = new window.File([data1], timestamp);
					var src = window.URL.createObjectURL(newFile);
					_this.newfilenow = newFile;
					_this.corappurl = src;
				}
			});
		},
		// 确定上传
		changeheadimg() {
			var form_data = new FormData();
			let fliepath = this.newfilenow;
			// console.log(fliepath)
			form_data.append('filename', fliepath);
			form_data.append('ui_guid', this.userSingleobj.ui_guid);
			setUploadAvatar(form_data).then(res => {
				if (res.data.code == 1) {
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					this.centerDialogVisible = false;
					this.handleClick(this.userSingleobj);
				} else {
					this.$message(res.data.msg, '格式默认人为jpg/png');
				}
			});
		},
		// 更改班级获取专业
		changeclassgetzy() {
			let zygetobj = {
				si_guid: this.userSingleobj.si_guid,
				cla_guid: this.userSingleobj.cla_guid
			};
			this.userSingleobj.cla_guid = '';
			this.classlist = [];

			if (this.userSingleobj.pro_guid != '') {
				GetProClassList(this.userSingleobj.pro_guid).then(res => {
					this.classlist = res.data.data;
				});
			}
		},
		getprosclsqs() {
			GetProClassList(this.userSingleobj.pro_guid).then(res => {
				this.classlist = res.data.data;
			});
		},

		//更改院校专业更改
		changeschool() {
			this.userSingleobj.cla_guid = '';
			this.userSingleobj.pro_guid = '';
			this.classzylist = [];
			this.classlist = [];
			// console.log(this.userSingleobj.si_guid)
			this.getsclasslist(this.userSingleobj.si_guid);
		},
		// 专业不分页
		getsclasslist(guid) {
			GetzyProfList(guid).then(res => {
				this.classzylist = res.data.data;
			});

			// ClassInfoGetClassList(guid).then(res => {
			// 	this.classlist = res.data.data;
			// });
		},
		// 专业不分页
		getclasszylist(guid) {
			// let zyobjs = {
			// 	si_guid: guid,
			// 	cla_guid: ''
			// }
			// console.log(zyobjs,"专业obj")
			GetProfListByclassid(guid).then(res => {
				// console.log(res, '专业不分页');
				this.classzylist = res.data.data;
			});
		},

		// 添加用户
		gouserslist() {
			this.$router.push({
				name: '添加用户'
			});
		},

		// 选择学校
		userschoolchenge() {
			// console.log(this.userschoolvalue)
			// this.userSingleobj.ui_guid = this.userschoolvalue
		},

		// 筛选
		getuserltype(command) {
			// console.log(command)
			this.typeutguid = command;
			this.getuserlist();
		},
		getuserlistas(command) {
			// console.log(command)
			this.scollid = command.si_guid;
			this.schoolname = command.si_name_cn;
			this.getuserlist();
		},
		// 获取用户类型列表
		getusertypes() {
			let usertypex = {
				pageIndex: 1,
				pageSize: 5,
				ut_typeName: ''
			};
			getGetPageUserTypeList(usertypex).then(res => {
				// console.log(res, "用户类型")
				this.usertypelist = res.data.data.list;
			});
		},
		// 获取学校列表
		getscoollist() {
			// this.getusertypes();
			GetbjGetSchoolList().then(res => {
				// console.log(res, "学校不分页")
				this.userschoollist = res.data.data;
				this.schoollist = res.data.data;
			});
		},

		// 确定修改
		okedits() {
			let oked = {
				ui_guid: this.userSingleobj.ui_guid,
				ui_email: this.userSingleobj.ui_email,
				ui_realName: this.userSingleobj.ui_realName,
				ui_sex: this.sexcs,
				ui_mobile: this.userSingleobj.ui_mobile,
				ui_signature: this.userSingleobj.ui_signature,
				si_guid: this.userSingleobj.si_guid,
				cla_guid: this.userSingleobj.cla_guid,
				ui_cards: this.userSingleobj.ui_cards,
				ui_joyNumber: this.userSingleobj.ui_joyNumber,
				ut_guid: this.userSingleobj.ut_guid,
				pro_guid: this.userSingleobj.pro_guid
			};
			// console.log(this.userSingleobj)
			// console.log(oked, "修改上传")
			/* 
			 else if (this.userSingleobj.ui_mobile == '' || this.userSingleobj.ui_email == '') {
			 	this.$message('手机号码或邮箱不能为空');
			 }
			 */

			if (this.userSingleobj.si_guid == '') {
				this.$message('学校不能为空');
			} else {
				getUpdateUserInfo(oked).then(res => {
					// console.log(res, "用户编辑")
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});

						if (this.userSingleobj.ui_guid == localStorage.getItem('uiguid')) {
							// console.log("相同用户", this.userSingleobj.si_guid)

							localStorage.setItem('siguid', this.userSingleobj.si_guid);
							this.scollid = this.userSingleobj.si_guid;
							// this.tabindex = 1;
							this.getuserlist();
							this.addshow = false;

							this.userschoollist.forEach(item => {
								if (this.userSingleobj.si_guid == item.si_guid) {
									this.schoolname = item.si_name_cn;
								}
							});
						} else {
							// console.log("不同用户")
							// this.tabindex = 1;
							this.getuserlist();
							this.addshow = false;
						}
					} else {
						this.$message(res.data.msg);
					}
				});
			}
		},
		// 搜索
		searchs() {
			this.getuserlist(this.input2);
		},
		// 四大按钮
		lookings(e) {
			// console.log(e)
			this.dioads = '查看';
			this.addshow = true;
			// this.userSingleobj = JSON.parse(JSON.stringify(e))
			// this.userSingleobj2 = JSON.parse(JSON.stringify(e))
			getUserSingle(e.ui_guid).then(res => {
				// console.log(res)
				this.userSingleobj = res.data.data;
			});
		},
		// 授权
		setqxanth() {
			let qxlist = {};
			let roleList = [];

			this.qxtaglists.forEach(item => {
				return roleList.push(item.id);
			});
			qxlist.roleList = roleList;
			qxlist.ui_guid = this.sqanthobj.ui_guid;
			// console.log(qxlist)
			SetUserPermissions(qxlist).then(res => {
				if (res.data.code == 1) {
					this.$message.success(res.data.msg);
					this.addshow = false;
					this.getuserlist();
				} else {
				}
			});
		},

		giveem(e) {
			this.dioads = '授权';
			this.addshow = true;
			this.sqanthobj = e;
			// this.qxtaglists
			if (e.UserRoleList.length > 0) {
				this.jstags = true;
				let qxtaglist = [];
				this.sqanthobj.UserRoleList.forEach((item, index) => {
					let qxlist = {};
					qxlist.type = '';
					qxlist.label = item.rl_name;
					qxlist.id = item.rl_guid;
					qxtaglist.push(qxlist);
				});
				this.qxtaglist = qxtaglist;
			} else {
				this.jstags = false;
				this.qxtaglist = [];
			}

			AuthoriyGetRoleList().then(res => {
				// console.log(res, "角色不分页")
				this.Authoriylist = res.data.data;
			});
		},
		handleCommandjsantu(comman) {
			// console.log(comman)
			this.jstags = true;
			let qxtagobj = {
				type: '',
				label: comman.rl_name,
				id: comman.rl_guid
			};
			this.qxtaglist.push(qxtagobj);
		},
		handleClosejs(tag) {
			this.qxtaglist.splice(this.qxtaglist.indexOf(tag), 1);
		},
		handleClose() {
			this.$confirm('确认关闭？')
				.then(_ => {
					this.addshow = false;
				})
				.catch(_ => {
					this.addshow = false;
				});
		},
		handleClick(e) {
			// console.log(e)
			this.dioads = '编辑';
			this.addshow = true;
			let objs = JSON.parse(JSON.stringify(e));
			// this.userSingleobj = e
			getUserSingle(e.ui_guid).then(res => {
				// console.log(res, "获取单个用户")
				this.userSingleobj = JSON.parse(JSON.stringify(res.data.data));
				this.sexcs = this.userSingleobj.ui_sex ? '1' : '0';
				this.userschoolvalue = objs.si_guid;
				this.userSingleobj.ui_signature = this.userSingleobj.ui_signature ?? '暂无签名';
				this.getsclasslist(this.userSingleobj.si_guid);

				// console.log(this.userSingleobj.si_guid,"编辑")
				// return
				let getzy = {
					si_guid: this.userSingleobj.si_guid,
					cla_guid: this.userSingleobj.cla_guid ?? ''
				};

				for (var il in this.userSingleobj) {
					this.userSingleobj[il] = this.userSingleobj[il] ?? '';
				}
				// console.log(this.userSingleobj)
				// this.getclasszylist(getzy);
				// this.getsclasslist(getzy.si_guid);
				this.getprosclsqs();

				// this.changeclassgetzy()
			});
		},

		clickprovisible(e) {
			let userobj = {
				ui_guid: e.ui_guid,
				isDelete: false
			};
			let uiguid = e.ui_guid;

			getDelete(userobj).then(res => {
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.getuserlist();
				} else {
					this.$confirm(res.data.msg + `<div style='color:red;'>当前记录删除后会删除关联数据且不能恢复，请谨慎选择</div>`, '删除失败', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						customClass: 'confirm',
						dangerouslyUseHTMLString: true
					})
						.then(() => {
							// console.log("有记录也删除")
							userobj = {
								ui_guid: e.ui_guid,
								isDelete: true
							};

							getDelete(userobj).then(res => {
								if (res.data.code == 1) {
									this.$message({
										message: '恭喜你，' + res.data.msg,
										type: 'success'
									});
									this.getuserlist();
								} else {
								}
							});
						})
						.catch(() => {});
				}
			});
		},
		deleusers(School) {},
		indexMethod(index) {
			return index + 1;
		},
		// 更改swich
		switchChangeFin(e) {
			// console.log(e)
			let edits = {
				ui_guid: e.ui_guid,
				sys_status: e.sys_status
			};
			getEditStatus(edits).then(res => {
				// console.log(res)
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
				} else {
					this.$message(res.data.msg);
				}
			});
		},
		// 获取用户列表
		getuserlist(sreach = null) {
			let userobj = {
				pageIndex: this.tabindex,
				pageSize: this.tabsnun,
				ui_userName: sreach == null ? this.input2 : sreach,
				si_guid: this.scollid,
				ut_guid: this.typeutguid
			};
			getPageUserTypeList(userobj).then(res => {
				// console.log(res)
				this.tableData = res.data.data.list;
				this.totalall = res.data.data.totalCount;

				this.tableData.forEach(item => {
					if (item.ui_sex) {
						item.usex = '男';
					} else {
						item.usex = '女';
					}
					let userrolist = [];
					item.UserRoleList.forEach(item => {
						userrolist.push(item.rl_name);
					});

					item.jslist = userrolist.join(',');
				});
				// console.log(this.tableData, "表格")
			});
		},
		// 导出表格
		outExcel() {
			// console.log("导出表")
			xlsx(this.doloads, this.listHander, '用户数据模板');
		}
	}
};
</script>

<style></style>
